var React = require('react');

function LogoDark (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M37.764 0.619998L31.536 26H22.86L19.368 10.448L15.804 26H7.128L0.972 0.619998H8.604L11.556 17.972L15.552 0.619998H23.292L27.18 17.828L30.132 0.619998H37.764Z","fill":"#0274DC","key":0}),React.createElement("path",{"d":"M64.2662 26H57.2102L47.8142 11.816V26H40.7582V0.619998H47.8142L57.2102 14.984V0.619998H64.2662V26ZM71.7055 26.288C70.4575 26.288 69.4495 25.952 68.6815 25.28C67.9375 24.584 67.5655 23.708 67.5655 22.652C67.5655 21.596 67.9375 20.72 68.6815 20.024C69.4495 19.328 70.4575 18.98 71.7055 18.98C72.9295 18.98 73.9135 19.328 74.6575 20.024C75.4255 20.72 75.8095 21.596 75.8095 22.652C75.8095 23.684 75.4255 24.548 74.6575 25.244C73.9135 25.94 72.9295 26.288 71.7055 26.288Z","fill":"#020202","key":1})]);
}

LogoDark.defaultProps = {"width":"76","height":"27","viewBox":"0 0 76 27","fill":"none"};

module.exports = LogoDark;

LogoDark.default = LogoDark;
